// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"ChangePasswordForm_wrapperComponent__2JSlR","formElement":"ChangePasswordForm_formElement__F9bbb","actions":"ChangePasswordForm_actions__zl-o7"};